<template>
  <section class="skin-main">
    <div class="skin-main_image hlgd">
      <Thumb
          :fontSize="25"
          :height="25"
          :image-height="250"
          :image-width="350"
          :item="item"
          :size="25"
          fetchpriority="high"
          image-sizes="500:500"
          loading="eager"
      />
    </div>
    <div class="skin-main--info">
      <div :class="{'f fs gap8': item?.team}">
        <TeamIcons v-if="item?.team" :team="item?.team || ''" style="flex-shrink: 0" />
        <Tags :item="item" />
      </div>
      <Title :name="itemTitle" />
      <!--      <div v-if="item.locals.description"-->
      <!--           class="skin-main&#45;&#45;desc hlgd"-->
      <!--           v-html="description">-->
      <!--      </div>-->
      <div v-if="item.locals.description" class="skin-main--desc hlgd">
        <span
            v-html="isExpanded ? description : description.length >= 120 ? description.slice(0, 120) + '...': description"></span>
        <button
            v-if="description.length >= 120"
            class="btn btn-default btn-link p0 mt8 fw600"
            @click="isExpanded = !isExpanded"
        >
          {{ isExpanded ? t('show_less') : t('show_more') }}
        </button>
      </div>
      <div class="skin-main_image hlgt">
        <Thumb
            :fontSize="25"
            :height="25"
            :image-height="250"
            :image-width="350"
            :item="item"
            :size="25"
            fetchpriority="high"
            image-sizes="500:500"
            loading="eager"
        />
      </div>
      <div class="skin-main--cards g g3 gap16 hlgd">
        <div class="skin-main--cards-item card-dark p16 rating-card">
          <p>{{
              t('Community rating')
            }}{{ item.rating?.rating ? ': ' + item.rating?.rating + '★' : '' }}</p>
          <UiRating :rating="item.userVote || item.rating?.rating || 0"
                    @rating-changed="setRating" />
          <span>{{ item.rating?.votes }} {{ t('Votes') }}</span>
        </div>

        <div
            v-if="item.price_statistics"
            class="skin-main--cards-item card-dark p16"
        >
          <p>{{ t('From last week') }}</p>
          <div class="rating">
            <i
                :class="`i-arrow-long ${sevenDaysPercentage > 0 ? 'green rot_180' : 'red'}`"
            ></i>
            <span class="price-item">
              {{ sevenDaysPercentage > 0 ? '+' : '-' }}
              <UiPrice
                  :price="Math.abs((item as any).current_price - (item as any).price_statistics.seven_day_average).toFixed(2)"
              />
            </span>
          </div>
          <span>{{ sevenDaysPercentage.toFixed(2) || 0 }}%</span>
        </div>

        <div
            v-if="item.price_statistics"
            class="skin-main--cards-item card-dark p16"
        >
          <p>{{ t('From last month') }}</p>
          <div class="rating">
            <i
                :class="`i-arrow-long ${monthPercentage > 0 ? 'green rot_180' : 'red'}`"
            ></i>
            <span class="price-item">
                {{ monthPercentage > 0 ? '+' : '-' }}
                <UiPrice
                    :price="Math.abs((item as any).current_price - (item as any).price_statistics.thirty_day_average).toFixed(2)"
                />
              </span>
          </div>
          <span>{{ monthPercentage.toFixed(2) || 0 }}%</span>
        </div>
      </div>

      <div class="hlgt">
        <div class="skin-main--info">
          <div class="skin-main--info_rating card-dark light f p16">
            <p>{{
                t('Community rating')
              }}{{ item.rating?.rating ? ': ' + item.rating?.rating + '★' : '' }}</p>
            <div class="f fcol fb">
              <UiRating :rating="item.userVote || item.rating?.rating || 0"
                        @rating-changed="setRating" />
              <span>{{ item.rating?.votes }} {{ t('Votes') }}</span>
            </div>
          </div>
        </div>
        <!--        <div v-if="item.locals.description" class="skin-main&#45;&#45;desc"-->
        <!--             v-html="removeHtmlTags(item.locals.description)">-->
        <!--        </div>-->
        <div v-if="item.locals.description" class="skin-main--desc">
          <span v-html="isExpanded ? description : description.slice(0, 120) + '...'"></span>
          <button
              v-if="item.locals.description.length > 120"
              class="btn btn-default btn-link p0 mt8 fw600"
              @click="isExpanded = !isExpanded"
          >
            {{ isExpanded ? t('show_less') : t('show_more') }}
          </button>
        </div>
        <div
            v-if="item.seven_days && item.seven_days.length"
            class="skin-main--cards card-dark g g2"
        >
          <div class="skin-main--cards-item card-dark p16">
            <p>{{ t('From last week') }}</p>
            <div class="rating">
              <i
                  :class="`i-arrow-long ${sevenDaysPercentage > 0 ? 'green rot_180' : 'red'}`"
              ></i>
              <span class="price-item">
                {{ sevenDaysPercentage > 0 ? '+' : '-' }}
                <UiPrice
                    :price="Math.abs((item as any).current_price - (item as any).price_statistics?.seven_day_average).toFixed(2)"
                />
              </span>
            </div>
            <span>{{ sevenDaysPercentage || 0 }}%</span>
          </div>
          <div class="skin-main--cards-item card-dark p16">
            <p>{{ t('From last month') }}</p>
            <div class="rating">
              <i
                  :class="`i-arrow-long ${monthPercentage > 0 ? 'green rot_180' : 'red'}`"
              ></i>
              <span class="price-item">
                {{ monthPercentage > 0 ? '+' : '-' }}
                <UiPrice
                    :price="Math.abs((item as any).current_price - (item as any).price_statistics?.thirty_day_average).toFixed(2)"
                />
              </span>
            </div>
            <span>{{ monthPercentage.toFixed(2) || 0 }}%</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import Thumb from './Children/Thumb.vue'
import Tags from './Children/Tags.vue'
import Title from './Children/Title.vue'
import {useI18n} from 'vue-i18n'
import {useResize} from '~/composables/resize'
import type {ItemPageInfo} from "~/graphql/generated/schema-types";
import {EventBus} from '~/composables/bus'
import {getUserVote, setItemRating} from "~/utils/api";
import TeamIcons from "~/components/Pages/Weapon/Components/TeamIcons.vue";

const props = defineProps<{
  item: ItemPageInfo
}>()

const {t} = useI18n()
const currW = useResize()
// const weekPrices.priceChange = ref<string | number>(0)
// const weekPrices.percentageChange = ref<string | number>(0)
// const monthPrice = ref<string | number>(0)
// const monthPrices.percentageChange = ref<string | number>(0)
const debounce = useDebounce()
const isExpanded = ref(false)

const sevenDaysPercentage = computed(() => {
      if (props.item.price_statistics?.seven_day_average && props.item?.current_price) {
        return ((props.item?.current_price - props.item.price_statistics?.seven_day_average) / props.item.price_statistics?.seven_day_average) * 100
      }
      return 0
    }
)
const monthPercentage = computed(() => {
      if (props.item.price_statistics?.thirty_day_average && props.item?.current_price) {
        return ((props.item?.current_price - props.item.price_statistics?.thirty_day_average) / (props.item?.price_statistics?.thirty_day_average || 0)) * 100
      }
      return 0
    }
)

// function calculatePriceChange(prices: number[], currentPrice: number) {
//   // Суммируем все цены за последние 7 дней
//   let total = prices.reduce((sum, price) => sum + price, 0);
//
//   // Вычисляем среднюю цену за 7 дней
//   let averagePrice = total / prices.length;
//
//   // Рассчитываем абсолютное изменение цены
//   let priceChange = currentPrice - averagePrice;
//
//   // Рассчитываем процентное изменение цены
//   let percentageChange = (priceChange / averagePrice) * 100;
//
//   // Возвращаем результаты в виде объекта
//   return {
//     priceChange: priceChange.toFixed(2) || 0,
//     percentageChange: percentageChange.toFixed(2) || 0,
//   };
// }

// let lastWeekPrices = computed(() => props.item.seven_days?.map(item => item?.min_price || 0) || [])// Цены за последние 7 дней
// let lastMonthPrices = computed(() => props.item.chart?.map(item => item?.min_price || 0) || []); // Цены за последние 7 дней
// let todayPrice = props.item.current_price || 0; // Цена сегодня
// const weekPrices = computed(() => calculatePriceChange(lastWeekPrices.value, todayPrice))
// const monthPrices = computed(() => calculatePriceChange(lastMonthPrices.value, todayPrice));

// weekPrice.value = priceChange
// weekPrices.percentageChange.value = percentageChange

// const {
//   priceChange: monthPriceChange,
//   percentageChange: monthPercentageChange
// } = calculatePriceChange(lastMonthPrices.value, todayPrice);
// monthPrice.value = monthPriceChange
// monthPercentage.value = monthPercentageChange
const route = useRoute()
const getLinkWithoutExterior = (name: string) => {
  return name.replace(/-(factory-new|minimal-wear|field-tested|well-worn|battle-scarred)/, '')
}

const itemTitle = computed(() => {
  let itemName = props.item?.locals?.localed_name || props.item?.market_hash_name || ''
  itemName = getLinkWithoutExterior(props.item?.link || '') === props.item?.link || route.params.exterior ? itemName : itemName.replace(/\s*\(.*?\)$/, "")

  return itemName
})

function removeHtmlTags(html?: string): string {
  if (!html) return html || ''
  // Удаление HTML-тегов
  let result = html.replace(/<\/?[^>]+(>|$)/g, "");
  // Удаление специфических символов и последовательностей, таких как \n и \
  result = result.replace(/\\n/g, " ").replace(/\\/g, "");
  // Удаление множественных пробелов, табуляций и переносов строк
  return result.replace(/\s+/g, ' ').trim();
}

const description = computed(() => removeHtmlTags(props.item?.locals?.description || ''))

const setRating = debounce(async (rating: number) => {
  try {
    const {data, errors} = await setItemRating(props.item.market_hash_name, rating)
    if (errors?.length) {
      throw new Error(errors[0].message)
    }
    EventBus.$emit('notify', {
      success: true,
      msg: t('thank_for_voting')
    })
    props.item.rating.rating = data.makeVote.rating
    props.item.rating.votes = data.makeVote.votes

    getUserVote(props.item.market_hash_name || '').then(res => {
      if (props.item) {
        props.item.userVote = res.data.getUserVote
      }
    })
  } catch (e: any) {
    EventBus.$emit('notify', {
      success: false,
      msg: e.message
    })
  }

}, 600)
</script>

<style lang="scss" scoped>

@use 'sass:color';

.skin-main {
  display: flex;
  gap: 3.2rem;

  &_image {
    width: 38.4rem;
    height: 38.4rem;
    background: rgba(33, 40, 53, 0.2);
    border-radius: .8rem;
    padding-top: 2rem;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    flex-shrink: 0;

    @media screen and (max-width: 525px) {
      width: 100%;
      min-width: 100%;
      margin-top: 10px;
    }

    .thumb {
      width: 100%;
      margin: auto 0;
    }
  }

  &--links {
    display: flex;
    justify-content: space-between;
    background: color-mix(in srgb, var(--accent-on-primary) 40%, transparent);
    // background: var(--accent-on-primary);
    border-radius: .8rem;
    margin: 1.6rem;
    @media screen and (max-width: 480px) {
      margin: 0;
      width: 100%;
      padding: 0.2rem 1rem;
    }
    @media screen and (max-width: 400px) {
      flex-wrap: wrap;
      .btn {
        width: 50%;
      }
    }

    .btn {
      height: 4rem;
      white-space: nowrap;
      padding: 1rem;
      font-weight: 400;

      &:after {
        content: '\e819';
        font-family: 'fontello';
        margin-left: 0.4rem;
      }

      &:hover {
        color: var(--surfaces-on-surface-variable);
      }
    }
  }

  &--info {
    flex-grow: 1;
  }

  &--desc {
    font-size: 1.6rem;
    line-height: 2;
    color: var(--surfaces-on-surface);
    opacity: 0.8;
    margin: 2.4rem 0;
    transition: max-height 0.3s ease;
  }

  &--cards {
    color: var(--surfaces-on-surface-variable);

    p {
      font-weight: 600;
    }

    .price-item {
      font-size: 1.6rem;
      display: flex;
    }

    .rating-card {
      min-width: 195px;
    }

    .rating {
      display: flex;
      align-content: center;
      font-weight: 800;
      padding: 0.8rem 0;
      color: var(--surfaces-on-surface);
      font-size: 1.6rem;

      i {
        margin-right: 0.8rem;
      }

      .green {
        transform: rotate(180deg);
      }
    }
  }
}

@media screen and (max-width: 979px) {
  .skin-main {
    display: block;
    margin-bottom: 1.6rem;

    &_image {
      margin: 0 auto 0.8rem;
    }

    &--cards {
      text-align: center;
      padding: 1.4rem;

      &-item {
        padding: 0;

        .rating {
          justify-content: center;
        }

        &:last-child {
          position: relative;

          &:before {
            content: '';
            position: absolute;
            left: 0;
            height: 6.3rem;
            border-right: 1px solid #252930;
            top: 0;
          }
        }
      }
    }
  }
}
</style>
